import * as React from "react";
// import Grid from "@mui/material/Grid";
// import Paper from "@mui/material/Paper";
// import Box from "@mui/material/Box";
// import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
// import { Link } from "react-router-dom";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
// import ReportsTables from "./ReportsTables";
import { Fab } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { CalendarMonth } from "@mui/icons-material";
import { useState, useEffect } from "react";
import Undertaking from "./undertaking";
import DetailofRatingCommite from "./DetailofRatingCommite";
import RatingMovement from "./RatingMovement";
import RatingmoventIGF from "./RatingmoventIGF";
import NewRatings from "./NewRatings";
import Movementmorethanone from "./movementmorethanone";
import DirectorsDetails from "./directorsDetails";
import SponsorshipDetails from "./sponsorshipDetails";
import CriteriaGroupDetails from "./criteriaGroupDetails";
import AnalystRotation from "./analystRotation";
import TeamRotation from "./teamRotation";
import LeadRcRotation from "./leadRcRotation";
import RatingUpgradeDowngrade from "./ratingUpgradeDowngrade";
import MonitoringSurveillance from "./monitoringSurveillance";
import Updatingofmethodologies from "./updatingofmethodologies";
import RatingsBetweenTwoDates from "./ratingsBetweenTwoDates";
import OutstandingOnSpecificDate from "./outstandingOnSpecificDate";
import ToBeReviewedRatings from "./toBeReviewedRatings";
import SwitchRating from "./switchRating";
import PvtRatings from "./PvtRatings";
import NewRatingAgreements from "./newRatingAgreements.js";
import RatingWd from "./RatingWd";
import IndicativeRating from "./indicativeRating";
import HrHirings from "./hrHirings";
import OperationalDetails from "./OperationalDetails";
import RcDetails from "./rcDetails";
import RcOverdue from "./rcOverdue";
import SectorStudies from "./sectorStudies";
import TrainingConducted from "./trainingConducted";
import ConsultanciesProvided from "./consultanciesProvided";
import ComplaintsHandled from "./complaintsHandled";
import ConsultanciesReceived from "./consultanciesReceived";
import Softwarechange from "./softwarechange";
import ListofDefault from "./listofDefault";
import VisOutstandingOnSpecificDate from "./visOutstandingOnSpecificDate";
import UnsolicitedRatings from "./unsolicitedRatings";
import FeeVariation from "./feeVariation";
import SecpPack from "./secpPack";
import IcBtwTwoDates from "./IcBtwTwoDates.js";


export default function ReportsTableComponent(props) {
  function useWindowSize() {
    const [size, setsize] = useState([window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setsize([window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [screenWidth] = useWindowSize();

  const GridHeadings = [
    {
      name: "Detail of Private Rating (vendor assessment)",
      link: "pvtratings",
      id: "1",
    },

    {
      name: "New Vendor Assessment Agreements",
      link: "newratingagreements",
      id: "2",
    },
 
  ];
  const location = useLocation();

  return (
    <div className="h-100">
      <div>
        {location.pathname.includes("Undertakings") && <Undertaking screenWidth={screenWidth} />}
        {location.pathname.includes("DetailofRatingCommiteeofCRA") && 
          <DetailofRatingCommite screenWidth={screenWidth} /> }
        {location.pathname.includes("MovementofEachCreditRatings") && 
          <RatingMovement screenWidth={screenWidth} />}
        {location.pathname.includes("ratingmoventinvestmentgradeform") && 
          <RatingmoventIGF screenWidth={screenWidth} />}
        {location.pathname.includes("NewCreditRatingsAssigned") && 
          <NewRatings screenWidth={screenWidth} />}
        {location.pathname.includes("VISOutstandingonthespecificDate") && <VisOutstandingOnSpecificDate screenWidth={screenWidth} />}
        {location.pathname.includes("DirectorsDetails") &&  <DirectorsDetails screenWidth={screenWidth} />}
        {location.pathname.includes("SponsorsDetails") && <SponsorshipDetails screenWidth={screenWidth} />}
        {location.pathname.includes("CriteriaGroupDetails") && <CriteriaGroupDetails screenWidth={screenWidth} />}
        {location.pathname.includes("AnalystRotation") && <AnalystRotation screenWidth={screenWidth} />}
        {location.pathname.includes("TeamRotation") && <TeamRotation screenWidth={screenWidth} />}
        {location.pathname.includes("LeadRCRotation") && <LeadRcRotation screenWidth={screenWidth} />}
        {location.pathname.includes("MovementMoreThanOneNotch") && <Movementmorethanone screenWidth={screenWidth} />}
        {location.pathname.includes("ratingsDowngradeupgrade") && <RatingUpgradeDowngrade screenWidth={screenWidth} />}
        {location.pathname.includes("monitoringsurveillance") && <MonitoringSurveillance screenWidth={screenWidth} />}
        {location.pathname.includes("updatingofmethodologies") && <Updatingofmethodologies screenWidth={screenWidth} />}
        {location.pathname.includes("BetweentwoDates") && <RatingsBetweenTwoDates screenWidth={screenWidth} />}
        {location.pathname.includes("OutstandingonspecificDate") && <OutstandingOnSpecificDate screenWidth={screenWidth} />}
        {location.pathname.includes("Duetobereviewedratings") && <ToBeReviewedRatings screenWidth={screenWidth} />}
        {location.pathname.includes("switchratings") && <SwitchRating screenWidth={screenWidth} />}
        {location.pathname.includes("pvtratings") && <PvtRatings screenWidth={screenWidth} />}
        {location.pathname.includes("Listofdefault") && <ListofDefault screenWidth={screenWidth} />}
        {location.pathname.includes("newratingagreements") && <NewRatingAgreements screenWidth={screenWidth} />}
        {location.pathname.includes("ratingwithdrawn") && <RatingWd screenWidth={screenWidth} />}
        {location.pathname.includes("indicativeratings") && <IndicativeRating screenWidth={screenWidth} />}
        {location.pathname.includes("newhiringHR") && <HrHirings screenWidth={screenWidth} />}
        {location.pathname.includes("operationdetails") && <OperationalDetails screenWidth={screenWidth} />}
        {location.pathname.includes("rcdetails") && <RcDetails screenWidth={screenWidth} />}
        {location.pathname.includes("rcoverdue") && <RcOverdue screenWidth={screenWidth} />}
        {location.pathname.includes("IndustrySpecificStudies") && <SectorStudies screenWidth={screenWidth} />}
        {location.pathname.includes("TrainingsConducted") && <TrainingConducted />}
        {location.pathname.includes("ConsultanciesProvided") && <ConsultanciesProvided />}
        {location.pathname.includes("ConsultanciesReceived") && <ConsultanciesReceived />}
        {location.pathname.includes("ComplaintsHandled") && <ComplaintsHandled />}
        {location.pathname.includes("SoftwareSystemChanges") && <Softwarechange />}
        {location.pathname.includes("Unsolicitedrating") && <UnsolicitedRatings screenWidth={screenWidth} />}
        {location.pathname.includes("VariationinFee") && <FeeVariation  />}
        {location.pathname.includes("rcdates") && <SecpPack />}
        {location.pathname.includes("IcBtwTwoDates") && <IcBtwTwoDates screenWidth={screenWidth} />}
        

        {/* <ReportsTables reportToOpen={reportToOpen} /> */}
      </div>
    </div>
  );
}

// <Box className={`p-1 mt-1 my-md-0 text-end text-md-center`}>
//   <>
//     <Fab
//       color="transparent"
//       aria-label="Date"
//       variant="extended"
//       className=" mb-1"
//     >
//       <CalendarMonth className="theme_text" />
//       <div className={`p-1 d-inline-flex`}>
//         <div className="m-1">
//           {/* <p className="theme_text me-1 my-auto"> From </p> */}
//           <input
//             type="date"
//             id="startDate"
//             //   onChange={(e) => setStartDate(e.target.value)}
//             className="px-1 btn_theme"
//             style={props.screenWidth < 400 ? { width: 125 } : null}
//           />
//         </div>
//         <div className="m-1">
//           {/* <p className="theme_text me-1 my-auto"> To </p> */}
//           <input
//             type="date"
//             id="endDate"
//             //   onChange={(e) => setEndDate(e.target.value)}
//             className="px-1 btn_theme"
//             style={props.screenWidth < 400 ? { width: 125 } : null}
//           />
//         </div>
//       </div>
//     </Fab>
//   </>
//   <Fab
//     color="neutral"
//     aria-label="edit"
//     variant="extended"
//     className="ms-2  mb-1"
//   >
//     <Autocomplete
//       id="val"
//       freeSolo
//       // autoSelect
//       // disableClearable
//       options={GridHeadings}
//       className="p-2"
//       getOptionLabel={(option) => option.name}
//       renderInput={(params) => (
//         <TextField
//           {...params}
//           // label="search reports here"
//           // defaultValue={(reportToOpen) => reportToOpen.name}
//           // hiddenLabel
//           // variant="outlined"
//           size="small"
//           style={{
//             width: "275px",
//             background: "#ffff",
//             //   height: "25px",
//           }}
//         />
//       )}
//       onChange={handleSearch}
//     />
//     <Search className="theme_text" />
//   </Fab>
// </Box>

{
  /* <div className="row container my-3">
<div className="col-md-4 p-3">
<TextField
    type="date"
    id="startDate"
    //   onChange={(e) => setStartDate(e.target.value)}
    className="btn_theme mx-3"
    variant="outlined"
    />
    <TextField
      type="date"
      id="endDate"
      //   onChange={(e) => setEndDate(e.target.value)}
      className="btn_theme mx-3"
      variant="outlined"
    />
    </div>
  <div className="col-md-4 p-3">
    <Autocomplete
    id="val"
      freeSolo
      autoSelect
      disableClearable
      options={GridHeadings}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => (
          <TextField
          {...params}
          label="Search for Reports"
          variant="outlined"
          />
          )}
          onChange={handleSearch}
          />
          </div>
</div> */
}

// const Item = styled(Paper)(({ theme }) => ({
//   ...theme.typography.body2,
//   textAlign: "center",
//   color: theme.palette.text.secondary,
//   height: 60,
//   lineHeight: "60px",
// }));

// const lightTheme = createTheme({ palette: { mode: "light" } });
